<template>
	<dms-list-layout v-bind="layoutProps">
		<div slot="filter">
		<dms-collapse :value.sync="mainCollapse">
			<dms-collapse-item label-key="GeneralCriteria" name="1" class="bt">
			<dms-input-number :value.sync="ZakaznikSk" label-key="ZAKAZNIK_SK" />
			<dms-input :value.sync="Text" label-key="TEXT" />
			</dms-collapse-item>
		</dms-collapse>
		</div>

		<dms-table slot="content" v-bind="tableModel" v-on="tableListeners" />
	</dms-list-layout>
</template>

<script>
import { listFactory } from '@/main/pages';

import { store } from './store/list';
import { NAME } from './constants';

export default listFactory(NAME, store);
</script>
